import { memo } from 'react';
import type { FieldWithLabelAndInputPT } from '@shared/ui/forms/FieldWithLabel/FieldWithLabelAndCard/types';
import { FormFieldWithLabelAndCard } from '@shared/ui/forms/FieldWithLabel/FieldWithLabelAndCard/ui';
import { TextInputM } from '@shared/ui/inputs/TextInputM/ui';

export const FormFieldWithLabelAndInput = memo(
  ({ fieldLabel, requiredField, helperText, ...props }: FieldWithLabelAndInputPT) => {
    return (
      <FormFieldWithLabelAndCard
        requiredField={requiredField}
        fieldLabel={fieldLabel}
        helperText={helperText}
      >
        <TextInputM {...props} />
      </FormFieldWithLabelAndCard>
    );
  }
);
